import React from 'react';
import { Flex, Heading, TableContainer, Table, Thead, Tr, Th, Td, Tbody, useColorModeValue } from '@chakra-ui/react';
import { formatAmount } from 'utils/util';

const TaxableAmount = ({ totals, isSameState, finalNetAmount, daybook, company }) => {
   const textColor = useColorModeValue('gray.800', 'white');
   const headerbg = useColorModeValue('gray.200', '#262b33');

   return (
      <Flex justifyContent="flex-end">
         <TableContainer maxH="999px" border="1px" borderColor="gray.200" borderRadius={5} maxWidth="xl">
            <Table variant="simple" size="sm" maxWidth="xl">
               <Thead bg={headerbg}>
                  <Tr>
                     <Th p={2} color={textColor} minW="200px" textAlign="center">
                        <Heading size="sm">Taxable Amount</Heading>
                     </Th>
                     <Th p={2} color={textColor} minW="150px" textAlign="center">
                        <Heading size="sm">{formatAmount(totals?.taxableAmount)}</Heading>
                     </Th>
                  </Tr>
                  <Tr>
                     <Th>Description</Th>
                     <Th>Amount</Th>
                  </Tr>
               </Thead>
               <Tbody>
                  {isSameState !== null && isSameState && daybook?.applyGst && company?.setting?.applyGST ? (
                     <>
                        <Tr>
                           <Td border="1px solid" borderColor="gray.200" p={2}>
                              CGST
                           </Td>
                           <Td border="1px solid" borderColor="gray.200" p={2}>
                              {formatAmount(totals?.netGstAmount / 2)}
                           </Td>
                        </Tr>

                        <Tr>
                           <Td border="1px solid" borderColor="gray.200" p={2}>
                              SGST
                           </Td>
                           <Td border="1px solid" borderColor="gray.200" p={2}>
                              {formatAmount(totals?.netGstAmount / 2)}
                           </Td>
                        </Tr>
                     </>
                  ) : null}

                  {isSameState !== null && !isSameState && daybook?.applyGst && company?.setting?.applyGST ? (
                     <>
                        <Tr>
                           <Td border="1px solid" borderColor="gray.200" p={2}>
                              IGST
                           </Td>
                           <Td border="1px solid" borderColor="gray.200" p={2}>
                              {formatAmount(totals?.netGstAmount)}
                           </Td>
                        </Tr>
                     </>
                  ) : null}

                  <Tr>
                     <Td border="1px solid" borderColor="gray.200" p={2}>
                        Round Off
                     </Td>
                     <Td border="1px solid" borderColor="gray.200" p={2}>
                        {formatAmount(Math.round(finalNetAmount) - finalNetAmount)}
                     </Td>
                  </Tr>
                  <Tr h="16">
                     <Td border="1px solid" borderColor="gray.200" p={2} fontWeight="semibold" fontSize="2xl">
                        Net Amount
                     </Td>
                     <Td border="1px solid" borderColor="gray.200" p={2} fontSize="2xl" fontWeight="bold">
                        {formatAmount(Math.round(finalNetAmount))}
                     </Td>
                  </Tr>
               </Tbody>
            </Table>
         </TableContainer>
      </Flex>
   );
};

export default TaxableAmount;
